import Sheet from 'shared/Sheet'
import TextField from 'shared/Forms/TextField'
import TextInput from 'shared/Inputs/TextInput'
import { PropsWithChildren } from 'react'
import { IProjectCheckpoint } from '../../projectCheckpoints.types'
import NumberInput from 'shared/Inputs/NumberInput'

interface IProps {
  checkpoint: Pick<IProjectCheckpoint, 'name' | 'duration'>
  onChange: (val: any, name: string) => void
}

const CheckpointSheet = (props: PropsWithChildren<IProps>) => {
  return (
    <Sheet>
      <div className='flex-lines'>
        <div className='grid-form-2'>
          <TextField header='Наименование'>
            <TextInput
              value={props.checkpoint.name}
              onChange={props.onChange}
              name='name'
              placeholder='Контрольная точка 1'
            />
          </TextField>
          <TextField header='Длительность в днях'>
            <NumberInput value={props.checkpoint.duration} onChange={props.onChange} name='duration' />
          </TextField>
        </div>
      </div>
      <div>{props.children}</div>
    </Sheet>
  )
}

export default CheckpointSheet
